import './App.css';
import Navbar from "./components/Navbar";
import {BrowserRouter, Switch, Route } from "react-router-dom";
import { createBrowserHistory } from "history";
import Home from './components/pages/Home';
import Service from './components/pages/Service';
import Footer from './components/Footer';
import ScrollToTop from "./components/ScrollToTop";
import Documents from './components/pages/Documents';
import Gallery from './components/pages/Gallery';
import Contact from './components/pages/Contact';

function App() {
  const historyConfig = {
    basename: '/ZpS'
  };
  const history = createBrowserHistory(historyConfig);

  return (
    <BrowserRouter basename={'/ZpS'} history={history}>
    <div className="content">
      <Navbar />
      <ScrollToTop />
      <Switch>
        <Route path="/" exact component={Home}/>
        <Route path="/Service" exact component={Service}/>
        <Route path="/Documents" exact component={Documents}/>
        <Route path="/Gallery" exact component={Gallery}/>
        <Route path="/Contact" exact component={Contact}/>
      </Switch> 
    </div>
    <Footer />
    </BrowserRouter>
  );
}

export default App;
